export const MAP_BG_URL =
  'https://s3.amazonaws.com/com.kyruus.cdn/lib/providermatch-consumer/images/mapbg.svg';
